import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    input: {
        position: 'absolute',
        width: 0,
        left: '50%',
        pointerEvents: 'none',
        border: 'none',
        outline: 'none',
        zIndex: -100
    }
});

// we use form.reportValidity() to check for required fields, but this ignores readonly/hidden inputs,
// so when we need required validation on a component with a readonly input, we insert this, which
// triggers required validation, but uses css/events to prevent user interaction
export const RequiredTrigger: React.FC<{value: any}> = ({ value }) => {

    const classes = useStyles();

    return (
        <input
            required
            className={classes.input}
            value={value}
            onChange={() => {}}
            onKeyDown={e => e.preventDefault()}
            onFocus={(e => e.currentTarget.blur())}
        />
    );
};
